// src/components/open-houses/checkin/KioskSetup.jsx
// Agent-facing setup screen shown before guest mode: pick a question
// template and set a 4-digit exit PIN.
import { useEffect, useState } from "react";
import { DEFAULT_TEMPLATE, BUILT_IN_TEMPLATES } from "../../../utils/checkinFlow";
import { listenCheckinTemplates } from "../../../utils/firebasefunctions";

export default function KioskSetup({ user, openHouse, onStart, onBack }) {
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState("standard");
  const [pin, setPin] = useState("");

  useEffect(() => {
    if (!user?.id) return;
    const unsub = listenCheckinTemplates(user.id, (rows) => {
      setTemplates(rows);
      // Preselect the most recently used template, if any.
      const last = rows.slice().sort((a, b) => (b.lastUsedAt || 0) - (a.lastUsedAt || 0))[0];
      if (last?.lastUsedAt) setTemplateId((cur) => (cur === "standard" ? last.id : cur));
    });
    return () => unsub && unsub();
  }, [user?.id]);

  const chosen =
    BUILT_IN_TEMPLATES.find((t) => t.id === templateId) ||
    templates.find((t) => t.id === templateId) ||
    DEFAULT_TEMPLATE;

  const canStart = /^\d{4}$/.test(pin);

  return (
    <div className="w-full max-w-md mx-auto text-white">
      <h1 className="font-serif text-3xl mb-1">Start Open House</h1>
      <p className="text-white/70 text-sm mb-6">
        {openHouse.propertyAddress?.split(",")[0]} · guests will see this device. Set a PIN to get back out.
      </p>

      <label className="block text-xs uppercase tracking-widest text-[#d4af6a] mb-2">Question set</label>
      <select
        value={templateId}
        onChange={(e) => setTemplateId(e.target.value)}
        className="w-full rounded-lg p-3 text-slate-900 mb-5"
      >
        {BUILT_IN_TEMPLATES.map((t) => (
          <option key={t.id} value={t.id}>{t.name}</option>
        ))}
        {templates.map((t) => (
          <option key={t.id} value={t.id}>{t.name}</option>
        ))}
      </select>

      <label className="block text-xs uppercase tracking-widest text-[#d4af6a] mb-2">4-digit exit PIN</label>
      <input
        value={pin}
        onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
        inputMode="numeric"
        placeholder="0000"
        className="w-full rounded-lg p-3 text-slate-900 tracking-[0.5em] text-center text-xl mb-6"
      />

      <button
        onClick={() => onStart({ template: chosen, pin })}
        disabled={!canStart}
        className="w-full bg-[#d4af6a] disabled:opacity-40 text-[#1a2238] font-bold rounded-full py-4 text-lg"
      >
        Enter Guest Mode
      </button>
      <button onClick={onBack} className="w-full text-white/60 text-sm mt-4">
        Back to Open Houses
      </button>
    </div>
  );
}
